module.exports = __webpack_public_path__ + "img/icone_dashboard_branco.d4baf7d3.svg";